import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';


const QuickActions = () => {
  const actions = [
    {
      id: 1,
      title: "Search Candidates",
      description: "Find new talent with advanced filters",
      icon: 'Search',
      color: 'primary',
      link: '/employer-search-interface'
    },
    {
      id: 2,
      title: "Manage Shortlists",
      description: "Review and organize saved candidates",
      icon: 'Bookmark',
      color: 'accent',
      action: 'shortlists'
    },
    {
      id: 3,
      title: "View Unlocked Profiles",
      description: "Access your purchased candidate profiles",
      icon: 'Unlock',
      color: 'success',
      action: 'unlocked'
    },
    {
      id: 4,
      title: "Team Management",
      description: "Manage team members and permissions",
      icon: 'Users',
      color: 'secondary',
      action: 'team'
    }
  ];

  return (
    <div className="bg-card rounded-xl p-6 shadow-elevation border border-border">
      <h3 className="text-lg font-semibold text-foreground mb-6">Quick Actions</h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {actions?.map((action) => (
          <div key={action?.id} className="group">
            {action?.link ? (
              <Link
                to={action?.link}
                className="block p-4 rounded-lg border border-border hover:border-primary/50 hover:bg-primary/5 transition-all duration-200"
              >
                <div className="flex items-start space-x-3">
                  <div className={`h-10 w-10 rounded-lg bg-${action?.color}/10 flex items-center justify-center group-hover:bg-${action?.color}/20 transition-colors`}>
                    <Icon name={action?.icon} size={20} className={`text-${action?.color}`} />
                  </div>
                  <div className="flex-1">
                    <h4 className="font-medium text-foreground group-hover:text-primary transition-colors">
                      {action?.title}
                    </h4>
                    <p className="text-sm text-muted-foreground mt-1">
                      {action?.description}
                    </p>
                  </div>
                  <Icon name="ArrowRight" size={16} className="text-muted-foreground group-hover:text-primary transition-colors" />
                </div>
              </Link>
            ) : (
              <button
                className="w-full text-left p-4 rounded-lg border border-border hover:border-primary/50 hover:bg-primary/5 transition-all duration-200"
                onClick={() => console.log(`Navigate to ${action?.action}`)}
              >
                <div className="flex items-start space-x-3">
                  <div className={`h-10 w-10 rounded-lg bg-${action?.color}/10 flex items-center justify-center group-hover:bg-${action?.color}/20 transition-colors`}>
                    <Icon name={action?.icon} size={20} className={`text-${action?.color}`} />
                  </div>
                  <div className="flex-1">
                    <h4 className="font-medium text-foreground group-hover:text-primary transition-colors">
                      {action?.title}
                    </h4>
                    <p className="text-sm text-muted-foreground mt-1">
                      {action?.description}
                    </p>
                  </div>
                  <Icon name="ArrowRight" size={16} className="text-muted-foreground group-hover:text-primary transition-colors" />
                </div>
              </button>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default QuickActions;